import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_athlete/calendar")({
  component: RouteComponent,
  ssr: true,
  staticData: {
    getBreadcrumb() {
      return {
        href: "/calendar",
        labelTranslationKey: "athleteCalendar.label",
      };
    },
  },
});

function RouteComponent() {
  return <Outlet />;
}
